import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TrAccordionModule } from '../../../../../shared/components/tr-accordion/tr-accordion.module';
import { TrCheckboxModule } from '../../../../../shared/components/tr-forms-inputs/tr-checkbox/tr-checkbox.module';
import { TrDocModule } from '../../../../../shared/components/tr-forms-inputs/tr-doc/tr-doc.module';
import { TrSpinnerButtonDirectiveModule } from '../../../../../shared/directives';
import { SvgIconModule } from '../../../svg-icon/svg-icon.module';
import { ValidateTokenComponent } from './validate-token.component';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
        TrDocModule,
        TrCheckboxModule,
        TrSpinnerButtonDirectiveModule,
        TrAccordionModule,
        ReactiveFormsModule,
    ],
    exports: [ValidateTokenComponent],
    declarations: [ValidateTokenComponent],
})
export class ValidateTokenModule { }
